import db from './db';
import RoomMessageModel from './room-messages-model';
import DirectMessageModel from './direct-message-model';
import AttachmentModel from './attachment-model';

export default db;

export { RoomMessageModel, DirectMessageModel, AttachmentModel };
